import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export function WriteReviewButton({
  disabled = false,
  hasEditableReview,
  onClick,
  size = 'sm',
  responsive = true,
  unreviewableReason
}) {
  const isReviewable = !unreviewableReason || unreviewableReason !== 'ReviewError.EDIT_PENDING' && hasEditableReview;
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `marketplace-ui-reviews.error.${unreviewableReason}`
    }),
    disabled: isReviewable,
    placement: "left",
    children: /*#__PURE__*/_jsx(Button, {
      onClick: onClick,
      use: hasEditableReview ? 'tertiary-light' : 'tertiary',
      size: size,
      disabled: disabled || !isReviewable,
      responsive: responsive,
      "data-test-id": hasEditableReview ? 'edit-review-button' : 'write-review-button',
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `marketplace-ui-reviews.write.${hasEditableReview ? 'edit' : 'new'}`
      })
    })
  });
}